import dashedLine from '../images/dashed-curved-download-line-mobile.svg'
import downArrowIcon from '../images/down-arrow-white-icon.svg'

type MobileScreen7Props = {
  anchorRef: React.RefObject<HTMLDivElement>
}

const MobileScreen7 = ({ anchorRef }: MobileScreen7Props) => {
  const { x, y } = anchorRef.current?.getBoundingClientRect()!
  return (
    <div className="flex gap-1 p-16 h-full bg-[#222222] bg-opacity-[.78] w-screen relative">
      <div
        className="flex flex-col items-center gap-4 w-[253px] opacity-1 absolute"
        style={{
          left: `${x + 50}px`,
          top: `${y - 150}px`,
        }}
      >
        <p className="text-orange font-decimal text-[22px]">
          Click on this button to download the data
        </p>
        <img src={dashedLine} alt="dashed line" className="self-start" />
        <div
          className="fixed bottom-0 left-0 justify-center items-center h-[80px]"
          id="screen3-container"
        >
          <div className="border-r-[1px] border-none flex p-4 ml-4 justify-center items-center h-full">
            <img
              src={downArrowIcon}
              alt="Arrow pointing down"
              width={24}
              height={25}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default MobileScreen7
